import Cookie from '@/ports-backend/Cookie';
import DeviceDetection from '@/ports-backend/DeviceDetection';
import DeviceOrientation from '@/ports-backend/DeviceOrientation';
import Document from '@/ports-backend/Document';
import Footer from '@/ports-backend/Footer';
import FullScreen from '@/ports-backend/FullScreen';
import GameFrame from '@/ports-backend/GameFrame';
import LivePersonChat from '@/ports-backend/LivePersonChat';
import Location from '@/ports-backend/Location';
import MessageBus from '@/ports-backend/MessageBus';
import MyAccount from '@/ports-backend/MyAccount';
import Promotions from '@/ports-backend/Promotions';
import Scroll from '@/ports-backend/Scroll';
import Tracking from '@/ports-backend/Tracking';
import UserAction from '@/ports-backend/UserAction';
import VisibilityChange from '@/ports-backend/VisibilityChange';
import Window from '@/ports-backend/Window';

const portsMap = {
  DeviceDetection,
  DeviceOrientation,
  Scroll,
  Location,
  Window,
  Document,
  GameFrame,
  Tracking,
  Cookie,
  MessageBus,
  Promotions,
  VisibilityChange,
  UserAction,
  FullScreen,
  LivePersonChat,
  Footer,
  MyAccount,
};

export default portsMap;
